export default __webpack_public_path__ + "static/media/10.52baa050.jpg";